/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
declare global {
  interface Window {
    NODE_ENV: string;
  }
}

export const getNodeEnv = () => window.NODE_ENV;
